let React = require("react");

let Toast = require("../../Toast.jsx");

let ContentServerClient =  require("../../../ContentServerClient.js");
let RegionUtil =  require("../../../util/RegionUtil.js");
let ApplicationContext =  require("../../../config/ApplicationContext.js");

class InvitationsToastHub extends React.Component {

    constructor(){
        super();

        // TODO fix this
        this.state = {invitedTo: {show: true, hubs: []}}
    }

    componentDidMount(){
        this.getInvitedTo();
    }

    handleInviteError(response, intent){
      const {handleError, history} = this.props;

      if(response.status == 400){
         handleError(response, intent + ".  The invitation may have been cancelled by the sender");
      } else {
         handleError(response, intent);
      }
    }

    acceptInvitation({lookup, hubId, region}){
        const {setLoading, history} = this.props;
        setLoading(true, "Accepting...");

        // The invite (and the hub) lives in `region`, so accept against that
        // region and carry it on the redirect - hub ids are per-region integers
        // that don't encode region, so DataHubPage needs it to fetch the hub
        // from the right region.
        ContentServerClient.acceptInvitation(this.handleInviteError.bind(this), {lookup, hubId}, region)
        .then(() => {
            setLoading(false);
            this.getInvitedTo();
            const regionParam = region ? `&region=${region}` : "";
            history.push(`/hubs/${hubId}-Loading/libraries?state=accepted${regionParam}`);
        })
        .catch((err) => setLoading(false))
    }

    rejectInvitation({lookup, hubId, hubname, region}){
        const {setLoading, history, location: {pathname}} = this.props;
        setLoading(true, "Rejecting...");

        ContentServerClient.rejectInvitation(this.handleInviteError.bind(this), {lookup, hubId}, region)
        .then(() => {
            setLoading(false);
            this.getInvitedTo();
            history.push(`${pathname}?state=rejected&hubname=${hubname}`);
        })
        .catch((err) => setLoading(false))
    }

    getInvitedTo(){
        const {setLoading} = this.props;
        // Invites live in the region of the hub they're for, so query every
        // region and tag each invite with its region (hub ids don't encode it).
        RegionUtil.getRegions()
            .then(regions => {
                let regionIds = Object.keys(regions || {});
                if(regionIds.length === 0) regionIds = [ApplicationContext.getHomeRegion()];
                // dont throw errors from toasts
                return Promise.all(regionIds.map(regionId =>
                    ContentServerClient.getInvitedToHub(()=>{}, regionId)
                        .then(({hubs}) => (hubs || []).map(h => Object.assign({}, h, {region: regionId})))
                        .catch(() => [])
                ));
            })
            .then(perRegion => {
                const hubs = [].concat(...perRegion);
                this.setState({invitedTo: {show: true, hubs}});
            })
            .catch(() => setLoading(false));
    }

    render() {
        const {invitedTo} = this.state;

        return  <Toast getTallestToast={this.props.getTallestToast} hasClose={false} show={invitedTo.show && invitedTo.hubs.length > 0} toastName="invitedTo" type="invitation">
                    {invitedTo.hubs.map(({id:hubId, name:hubname, owner:{name}, invite: [{lookup}], region}) =>
                        <div className="contInvitation" key={`${region}-${hubId}`}>
                            <p className="text"><span className="bold">{name}</span> has invited you to edit the {fullHubAlias} <span className="bold">{hubname}</span></p>
                            <div className="contOptions">
                                <button className="button" onClick={() => this.acceptInvitation({lookup, hubId, region})}>Accept Invitation</button>
                                <button className="button transparent" onClick={() => this.rejectInvitation({lookup, hubId, hubname, region})}>Decline Invitation</button>
                            </div>
                        </div>
                    )}
                </Toast>
    }
}

module.exports = InvitationsToastHub;
